<template>
  <li :class="classList" @click="hideMobile">
    <slot></slot>
  </li>
</template>

<script>
import { hideMobile } from '@/mixins/hideMobile';

export default {
  name: 'sidebar-nav-item',
  mixins: [ hideMobile ],
  props: {
    classes: {
      type: [String, Array, Object],
      default: '',
    },
  },
  computed: {
    classList() {
      return [
        'nav-item',
        ...this.itemClasses,
      ];
    },
    itemClasses() {
      const classes = this.classes;
      if (!classes) return [];
      if (typeof classes === 'string' || classes instanceof String) {
        return classes.split(' ');
      }
      if (Array.isArray(classes)) {
        return classes;
      }
      return Object.keys(classes).filter((i) => classes[i]);
    },
  },
};
</script>
